// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"84b61b32","849":"3243104a"}[chunkId] + ".chunk.js";
};